import React, { useState } from "react";
import PropTypes from "prop-types";
import AgencyTeamCardHeader from "./header";
import AgencyTeamCardBody from "./body";

function AgencyTeamCard({
  userDetails = {},
  userDomains = [],
  userSubDomains = [],
  users = [],
  updateUsersResult = () => {},
  filterQuery = {},
}) {
  return (
    <div className="grid  md-max:grid-cols-1 grid-cols-2  w-full h-full items-center gap-[20px]">
      {users.map((user, i) => {
        return (
          <TeamMemberCard
            key={user.id + i}
            user={user}
            userDetails={userDetails}
            userDomains={userDomains}
            userSubDomains={userSubDomains}
            updateUsersResult={updateUsersResult}
            filterQuery={filterQuery}
          />
        );
      })}
    </div>
  );
}

function TeamMemberCard({
  user,
  userDetails,
  userDomains,
  userSubDomains,
  updateUsersResult,
  filterQuery,
}) {
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);

  return (
    <div
      className={`flex flex-col flex-1 w-full h-full py-[20px] px-[16px] gap-[16px] border-[1px] border-solid border-default-color rounded-[8px] cursor-pointer transition-colors ${
        isEditShowEditOnHover ? "bg-[#F3F5F7]" : ""
      }`}
      onMouseEnter={() => setShowEditOnHover(true)}
      onMouseLeave={() => setShowEditOnHover(false)}
    >
      <AgencyTeamCardHeader
        userDetails={userDetails}
        userDomains={userDomains}
        userSubDomains={userSubDomains}
        user={user}
        updateUsersResult={updateUsersResult}
        filterQuery={filterQuery}
        isEditShowEditOnHover={isEditShowEditOnHover}
      />

      <AgencyTeamCardBody user={user} />
    </div>
  );
}

AgencyTeamCard.propTypes = {
  userDetails: PropTypes.object,
};

export default AgencyTeamCard;
